import { render, staticRenderFns } from "./OrdersFilter.vue?vue&type=template&id=6ff0189c&lang=pug"
import script from "./OrdersFilter.vue?vue&type=script&lang=js"
export * from "./OrdersFilter.vue?vue&type=script&lang=js"
import style0 from "./OrdersFilter.vue?vue&type=style&index=0&id=6ff0189c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports